import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center me-2"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 1,
  style: {"width":"2.5rem"},
  class: "d-flex flex-column"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = ["checked"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["checked"]
const _hoisted_9 = ["disabled", "title"]
const _hoisted_10 = ["disabled", "title"]
const _hoisted_11 = ["disabled", "title"]
const _hoisted_12 = ["disabled", "title"]
const _hoisted_13 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_14 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "d-flex float-start"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.showControls && (_ctx.isAdmin || _ctx.isOperator) && _ctx.trader !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.trader.isBlocked)
                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                    key: 0,
                    title: _ctx.helper.trans('labels.user_blocked'),
                    class: "fa fa-ban text-danger text-center",
                    style: {"width":"2.5rem"}
                  }, null, 8, _hoisted_3)), [
                    [
                      _directive_b_tooltip,
                      void 0,
                      void 0,
                      { hover: true }
                    ]
                  ])
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _withDirectives((_openBlock(), _createElementBlock("small", {
                      class: "form-switch",
                      title: `${_ctx.helper.trans('direction.in')}: ${_ctx.helper.trans(_ctx.trader.isActive ? 'trader.status.active' : 'trader.status.inactive')}`
                    }, [
                      _createElementVNode("input", {
                        id: "traderStatus",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleTraderStatus(_ctx.trader.id, !_ctx.trader.isActive, _ctx.Direction.PAY_IN)), ["prevent"])),
                        class: "form-check-input",
                        style: {"cursor":"pointer"},
                        type: "checkbox",
                        role: "switch",
                        checked: _ctx.trader.isActive
                      }, null, 8, _hoisted_6)
                    ], 8, _hoisted_5)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        {
                          hover: true,
                          left: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("small", {
                      class: "form-switch",
                      title: `${_ctx.helper.trans('direction.out')}: ${_ctx.helper.trans(_ctx.trader.isPayOutActive ? 'trader.status.active' : 'trader.status.inactive')}`
                    }, [
                      _createElementVNode("input", {
                        id: "traderStatus",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleTraderStatus(_ctx.trader.id, !_ctx.trader.isPayOutActive, _ctx.Direction.PAY_OUT)), ["prevent"])),
                        class: "form-check-input",
                        style: {"cursor":"pointer"},
                        type: "checkbox",
                        role: "switch",
                        checked: _ctx.trader.isPayOutActive
                      }, null, 8, _hoisted_8)
                    ], 8, _hoisted_7)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        {
                          hover: true,
                          left: true
                        }
                      ]
                    ])
                  ])),
              _createElementVNode("div", null, [
                (!_ctx.trader.isPayInTrafficBlocked)
                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                      key: 0,
                      disabled: _ctx.trader.isBlocked,
                      title: _ctx.helper.trans('trader.status.active'),
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleTraderTraffic(_ctx.trader, _ctx.Direction.PAY_IN, false)), ["prevent"])),
                      class: "btn-sm btn btn-outline-success"
                    }, _cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "fa fa-circle-play" }, null, -1)
                    ]), 8, _hoisted_9)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        { hover: true }
                      ]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("button", {
                      key: 1,
                      disabled: _ctx.trader.isBlocked,
                      title: _ctx.helper.trans('labels.traffic_blocked'),
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.toggleTraderTraffic(_ctx.trader, _ctx.Direction.PAY_IN, true)), ["prevent"])),
                      class: "btn btn-sm btn-outline-warning"
                    }, _cache[7] || (_cache[7] = [
                      _createElementVNode("i", { class: "fa fa-circle-pause" }, null, -1)
                    ]), 8, _hoisted_10)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        { hover: true }
                      ]
                    ]),
                (!_ctx.trader.isPayOutTrafficBlocked)
                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                      key: 2,
                      disabled: _ctx.trader.isBlocked,
                      title: _ctx.helper.trans('trader.status.active'),
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.toggleTraderTraffic(_ctx.trader, _ctx.Direction.PAY_OUT, false)), ["prevent"])),
                      class: "ms-2 btn btn-sm btn-outline-success"
                    }, _cache[8] || (_cache[8] = [
                      _createElementVNode("i", { class: "fa fa-circle-play" }, null, -1)
                    ]), 8, _hoisted_11)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        { hover: true }
                      ]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("button", {
                      key: 3,
                      disabled: _ctx.trader.isBlocked,
                      title: _ctx.helper.trans('labels.traffic_blocked'),
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.toggleTraderTraffic(_ctx.trader, _ctx.Direction.PAY_OUT, true)), ["prevent"])),
                      class: "ms-2 btn btn-sm btn-outline-warning"
                    }, _cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "fa fa-circle-pause" }, null, -1)
                    ]), 8, _hoisted_12)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        { hover: true }
                      ]
                    ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", null, [
                (_ctx.showBadge)
                  ? _withDirectives((_openBlock(), _createElementBlock("small", {
                      key: 0,
                      class: _normalizeClass(["badge me-1", _ctx.getBadgeClass(_ctx.user.role)]),
                      title: _ctx.helper.trans(`user_roles.${_ctx.user.role}`)
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.helper.trans(`user_roles.shorts.${_ctx.user.role}`)), 1)
                    ], 10, _hoisted_14)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        { hover: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.user.name), 1)
              ]),
              _createElementVNode("small", null, _toDisplayString(_ctx.user.email), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 512))
}